import { styled } from '@components-shared/src/stitches';
import { inputDefaultStyles, textAreaBreakpointStyles } from '../inputStyles';

export const InputArea = styled('textarea', {
  ...inputDefaultStyles,
  ...textAreaBreakpointStyles.default,
  resize: 'none',
  outlineStyle: 'none',

  '@tablet': {
    ...textAreaBreakpointStyles.tablet,
  },
});
